import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
import { AccountMembershipRole } from '~/types/types';
export function getMembershipRoles(account) {
  return (account === null || account === void 0 ? void 0 : account.membershipRoles) || [];
}
export function isAccountAdminForAccount(account) {
  return getMembershipRoles(account).includes(AccountMembershipRole.Admin);
}
export function useIsAccountAdmin(account) {
  return computed(function () {
    return isAccountAdminForAccount(account.value);
  });
}
export function normalizeMembershipRoleKey(role) {
  if (role == null) return null;
  var value = String(role).toUpperCase();
  if (value === 'REVIEWER') return 'REVIEWER';
  if (value === 'ADMIN') return 'ADMIN';
  if (value === 'EDITOR') return 'EDITOR';
  return null;
}
var IX_USER_EMAIL_SUFFIXES = ['@impactnexus.io', '@impactnexus.ai', '@impactnexus.de'];
export function isIxUserEmail(email) {
  if (!email) {
    return false;
  }
  var normalized = email.trim().toLowerCase();
  return IX_USER_EMAIL_SUFFIXES.some(function (suffix) {
    return normalized.endsWith(suffix);
  });
}
export function membershipRoleChipClasses(role) {
  switch (normalizeMembershipRoleKey(role)) {
    case 'EDITOR':
      return 'membership-role-chip--editor';
    case 'REVIEWER':
      return 'membership-role-chip--reviewer';
    case 'ADMIN':
      return 'membership-role-chip--admin';
    default:
      return '';
  }
}